import { mergeConfigPage } from '@/utils/common.utils';

export const normalizeBusinessProps = (response, path) => {
  const resp = { ...response };
  resp.modalAtencionConfig = mergeConfigPage(resp.modalAtencionConfig, path);

  return resp;
}
